exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-upload>input{display:none}.image-upload img{width:80px;cursor:pointer}", ""]);

// exports
